/* Dori chat widget — panel header accent.
   ---------------------------------------------------------------------------
   Same shadow-DOM situation as kbh-dori-size.js: Dori mounts into an OPEN
   shadow root, so page stylesheets (kbh-global.css) can't reach it, !important
   included. Because the root is open we append our own <style> INSIDE it.

   Goal: give the open panel's top bar the brand bronze (#8A6A30) instead of the
   default white, and flip its title + icons to a light cream so they stay
   legible on the dark background.

   The header is the 40px flex row at the top of the panel. Its Emotion hash
   class (root-1cw6h6b) changes per build, so it is reached structurally: it is
   the only div that directly contains BOTH the avatar `img.chakra-image` AND
   the close button `[aria-label="Aizvērt"]`. Verified unique on live (2026-08).
   If the store's language changes, update the "Aizvērt" (LV "Close") anchor.

   Scope is the header only — the greeting and message body are untouched.
   Kept separate from kbh-dori-size.js on purpose (own marker, own concern).
   --------------------------------------------------------------------------- */
(function () {
  var HDR = 'div:has(> img.chakra-image):has(button[aria-label="Aizvērt"])';
  /* The rounded, cream, overflow:hidden panel wrapping the whole widget. Reached
     with a single :has() down to the avatar (:has() can't be nested, so we can't
     walk up from HDR). Verified to match only that panel on live. */
  var PANEL = 'div:has(> div.chakra-stack > div > img.chakra-image)';
  var BG = '#8A6A30';   /* brand bronze — header bg + panel border */
  var FG = '#FFF7EC';   /* cream — header title + icons on the bronze */
  var DK = '#3A2C10';   /* dark bronze — text/icon on the light pill button */

  /* Full-bleed the header. The header itself has 0 padding, but its parent
     (chakra-stack) pads the panel by 24px top/left/right, and the grandparent
     is the cream, 24px-rounded, overflow:hidden panel. So we cancel that 24px
     with negative margins and re-add it as the header's own padding — the
     bronze then paints edge to edge, and the panel's rounded overflow clips the
     top corners. The 24px must track the panel's padding/radius if Dori changes
     it; verified on live 2026-08. */
  var CSS =
    HDR + '{background:' + BG + '!important;' +
      'margin:-24px -24px 0!important;padding:24px 24px 16px!important;' +
      'border-top-left-radius:24px!important;border-top-right-radius:24px!important}' +
    /* Header logo — bumped from the native 40px for a bit more presence. */
    HDR + ' > img.chakra-image{width:56px!important;height:56px!important}' +
    HDR + ' *{color:' + FG + '!important}' +
    HDR + ' svg{color:' + FG + '!important;fill:' + FG + '!important;stroke:' + FG + '!important}' +
    HDR + ' path{fill:' + FG + '!important;stroke:' + FG + '!important}' +
    /* The fullscreen button ("Pilnekrāna režīms") is the only header button with
       no aria-label (the close one is aria-label="Aizvērt"). It has its own light
       pill background, so the blanket cream rule above made its label invisible.
       Re-assert a light pill with dark text/icon so it stays legible on bronze. */
    HDR + ' button:not([aria-label]){background:#F5F1E8!important;color:' + DK + '!important}' +
    HDR + ' button:not([aria-label]) svg{color:' + DK + '!important;fill:' + DK + '!important;stroke:' + DK + '!important}' +
    HDR + ' button:not([aria-label]) path{fill:' + DK + '!important;stroke:' + DK + '!important}' +
    /* Panel frame in brand bronze instead of the default light-gray hairline. */
    PANEL + '{border-color:' + BG + '!important}';

  var MARK = 'data-kbh-dori-hdr';

  function inject(root) {
    if (!root || root.querySelector('style[' + MARK + ']')) return false;
    var s = document.createElement('style');
    s.setAttribute(MARK, '');
    s.textContent = CSS;
    root.appendChild(s);
    return true;
  }

  function findRoot() {
    var all = document.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var sr = all[i].shadowRoot;
      if (sr && sr.querySelector('button.fab-glass, img.chakra-image')) return sr;
    }
    return null;
  }

  function tick() {
    var root = findRoot();
    if (root && inject(root)) {
      /* the app re-renders its own styles; keep ours present if it wipes them */
      new MutationObserver(function () { inject(root); })
        .observe(root, { childList: true });
      return true;
    }
    return false;
  }

  if (tick()) return;
  var tries = 0;
  var timer = setInterval(function () {
    if (tick() || ++tries > 60) clearInterval(timer);   /* give up after ~60s */
  }, 1000);
})();
